import { useDispatch, useSelector } from 'react-redux';

export const useRedux = () => {
    const dispatch = useDispatch();

    return {
        dispatch,
    };
};
